import React, { useState, useEffect } from "react";
import { Frame } from "@bitesite/react-figstrap";
import PropTypes from "prop-types";
import { selectionButtonType } from "../common/utilities";
import ErrorText from "../common/error_text";
import { Button } from "../../../odc-ui";

const SubscriptionPlanSelection = ({
  selectedSubscriptionPlan,
  onSubscriptionPlanClick,
  theme,
  showOnlyIfThereIsMoreThanOnePlan,
}) => {
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [loadingSubscriptionPlans, setLoadingSubscriptionPlans] =
    useState(true);

  const loadSubscriptionPlans = () => {
    $.getJSON("/subscription_plans", (results) => {
      setSubscriptionPlans(results);
      setLoadingSubscriptionPlans(false);

      if (results.length === 1 && showOnlyIfThereIsMoreThanOnePlan) {
        onSubscriptionPlanClick(results[0]);
      }
    });
  };

  useEffect(() => {
    loadSubscriptionPlans();
  }, []);

  if (showOnlyIfThereIsMoreThanOnePlan && subscriptionPlans.length <= 1) {
    return null;
  }

  return (
    <Frame vertical gap={10}>
      <div>Which Auto Grow plan would you like to subscribe to?</div>

      <Frame vertical gap={10}>
        {loadingSubscriptionPlans ? (
          "Loading plans..."
        ) : (
          <>
            {subscriptionPlans.length === 0 ? (
              <ErrorText>
                We&apos;re still in the process of setting up our plans. Please
                check back later.
              </ErrorText>
            ) : (
              subscriptionPlans.map((subscriptionPlan) => (
                <Button
                  type={selectionButtonType(
                    theme,
                    selectedSubscriptionPlan &&
                      selectedSubscriptionPlan.id === subscriptionPlan.id
                  )}
                  key={subscriptionPlan.id}
                  onClick={() => {
                    onSubscriptionPlanClick(subscriptionPlan);
                  }}
                  textTransform="none"
                >
                  {subscriptionPlan.name}
                </Button>
              ))
            )}
          </>
        )}
      </Frame>
    </Frame>
  );
};

SubscriptionPlanSelection.defaultProps = {
  showOnlyIfThereIsMoreThanOnePlan: false,
};

SubscriptionPlanSelection.propTypes = {
  selectedSubscriptionPlan: PropTypes.object,
  onSubscriptionPlanClick: PropTypes.func.isRequired,
  showOnlyIfThereIsMoreThanOnePlan: PropTypes.bool,
  theme: PropTypes.string,
};

export default SubscriptionPlanSelection;
